import React, { useEffect, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import TitleSwiper from '../title-swiper'
import { SimpleProducts } from '../../../../../../listing/components/list'

export default props => {
    useStyles(classes)
    const { recs, isTitle } = props
    const [rec, setRec] = useState(recs?.[0])

    useEffect(() => {
        setRec(recs?.[0])
    }, [recs])

    return recs?.length > 0 ? <div className={classes.Container}>
        <div className={classes.Hd}>
            {
                isTitle ? <FormattedMessage id="you_like_fill_it" defaultMessage="You Might Like to Fill it With" /> : <FormattedMessage id="you_may_also_likes" defaultMessage="You May Also Likes" />
            }
        </div>
        {
            recs?.length > 1 && <div className={classes.Tabs}>
                <TitleSwiper items={recs} onTab={setRec} selectedItem={rec} />
            </div>
        }
        <div>
            <SimpleProducts mode='show_editor' products={rec?.products} sensors={{
                resourcepage_title: 'cart',
                resource_position: '1',
                resource_type: '4',
                resource_content: 'You Might Like to Fill it With'
            }} />
        </div>

    </div>: <></>
}